module.exports = __webpack_public_path__ + "img/Weapon_103.e4a03037.png";